import { CheckboxIntermediateIcon } from './CheckboxIntermediateIcon';

/**
 * author: Michael Richins
 * id EFD12742-D508-4531-A9A4-EDCF3148C748
 * name checkbox-intermediate
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-intermediate.svg
 * tags
 * - Form 
 */
export const CheckboxIndeterminateIcon = CheckboxIntermediateIcon;
export default CheckboxIndeterminateIcon